module.exports = __webpack_public_path__ + "static/media/LeftRightArrow (1).a2ba2f4a.png";